// Net / gross price toggle. The value is applied to <html data-vat> before paint by an inline
// script in theme.liquid; this file only handles clicks and keeps the buttons in sync.
(function () {
  var KEY = 'ezb-vat';
  function apply(mode) {
    document.documentElement.setAttribute('data-vat', mode);
    document.querySelectorAll('[data-vat-set]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-vat-set') === mode ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vat-set]');
    if (!btn) return;
    var mode = btn.getAttribute('data-vat-set');
    try { localStorage.setItem(KEY, mode); } catch (err) {}
    apply(mode);
  });
  document.addEventListener('DOMContentLoaded', function () {
    var mode = document.documentElement.getAttribute('data-vat') || 'net';
    apply(mode);
  });
})();

// EZB accessibility patch (product page quantity field).
// The quantity <label> carries an aria-labelledby that points at an id which does not exist, so the quantity
// input ends up without an accessible name (Lighthouse: "Form elements do not have associated labels" and
// Agentic Browsing: "Accessibility tree is not well-formed"). This removes dangling references and makes sure
// the input has a name. Safe to delete once the template markup in sections/main-product.liquid is fixed.
(function () {
  function labelText(label) {
    var own = Array.prototype.filter.call(label.childNodes, function (n) { return n.nodeType === 3; })
      .map(function (n) { return n.textContent; }).join(' ').replace(/\s+/g, ' ').trim();
    return own || (label.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function fixQuantity() {
    document.querySelectorAll('label.quantity__label[aria-labelledby]').forEach(function (label) {
      var ids = (label.getAttribute('aria-labelledby') || '').split(/\s+/).filter(Boolean);
      var dangling = ids.some(function (id) { return !document.getElementById(id); });
      if (dangling) label.removeAttribute('aria-labelledby');
    });
    document.querySelectorAll('input.quantity__input').forEach(function (input) {
      if (input.hasAttribute('aria-label') || input.hasAttribute('aria-labelledby')) return;
      var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
      var text = label ? labelText(label) : '';
      if (text) input.setAttribute('aria-label', text);
    });
  }
  function init() {
    if (!document.querySelector('.quantity__input')) return;
    fixQuantity();
    // The product section can be re-rendered when a variant changes; re-apply after DOM updates.
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fixQuantity(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
